/**
 * maps translation response from API to message object for i18n plugin
 * @param {Array[Object]} translations
 */
export const mapToI18nObject = translations => {

    return translations.length > 0 ? Object.assign(
        ...translations.map(item => {
            return { [item.key]: item.text };
        })
    ) : {}
}